import React from 'react'
import { about2, abouticon1, abouticon3, aboutmain, aboutnew, aboutuslast, img1, line, mission, vision, whyus1, whyus2, whyus3 } from '../../assets/imagesPath'
import { aboutusData } from '../../data/ChooseUsData'
import ChooseUsCard from '../../components/ChooseUsCards/ChooseusCard'
import CarouselComponent from '../../components/Carousel/CarouselComponent'
const AboutUs = () => {
  return (
    <>
      {/* <div className="bg-[#EFF7F8] text-center py-40 ">
        <span className="bg-blue-200 text-black text-[1.2rem] px-8 py-2 rounded-full font-semibold uppercase">
          About
        </span>
        <h1 className="text-[3.6rem] font-bold mt-3 smallScreens:text-[2rem]">About Us</h1>
       <p className="text-[1.6rem] text-dark mt-4 smallScreens:text-[1rem]">
          <span className="text-dark">Home</span> / About Us
        </p>
      </div> */}
      <div className="bg-white pt-12 px-4 smallScreens:px-6 smallScreens:pt-6 lg:px-8">
        <div className='flex items-center justify-center gap-12'>
          <img src={line} alt="" className='h-1 w-7' />
          <p className='text-xl smallScreens:text-[1rem] font-bold text-[#818891]'>SBAAA LLC</p>
          <img src={line} alt="" className='h-1 w-7' />
        </div>
        <div className='flex items-center justify-center mt-8'>
          <h1 className='font-bold text-[3.4rem] text-center w-2/5 smallScreens:text-[2rem]'>About Us</h1>
        </div>
        <div className="w-4/5 mx-auto flex flex-col md:flex-row items-center py-20">
          <div className="w-4/5 mediumScreens:mr-20">
            <img
              src={aboutmain}
              alt="Team working"
              className="rounded-lg shadow-lg object-cover w-[55.153rem] h-[38.294rem] smallScreens:h-60 "
            />
          </div>
          <div className="w-full md:w-2/3">
            <div className="mb-6">
              <h3 className="text-[1.8rem] font-semibold text-[#173363] mb-2 smallScreens:mt-8">
                Supporting the Backbone of Small Business in America
              </h3>
              <p className="text-[#64666C]  leading-relaxed text-[1.6rem] mt-6">
              At SBAAA LLC, we are committed to empowering small business owners and entrepreneurs with the financial tools, advisory support, and administrative services necessary to succeed. Our offerings are designed to simplify complex processes, provide timely and actionable insights, and promote sustainable.
              </p>
            </div>

            <div>
              <h3 className="text-[1.8rem] font-semibold  text-[#173363] mb-2">
                Your Partner in Small Business Success
              </h3>
              <p className="text-[#64666C] leading-relaxed text-[1.6rem] mt-6">
                At SBAAA LLC, we understand the unique challenges you face as a
                small business owner. Balancing day-to-day operations while trying
                to grow your business can feel overwhelming. That's why we've
                created a comprehensive suite of services, programs, and
                partnerships designed to empower you with the tools, knowledge,
                and connections you need to thrive.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#F2F2F282] py-10 px-4 sm:px-6 lg:px-8">
        <div className="w-4/5 mx-auto flex flex-col md:flex-row items-center gap-20">
          <div className="w-3/4 ">
            <div className='flex items-start justify-start gap-12 mt-[5.8rem] smallScreens:mt-0'>
              <img src={line} alt="" className='h-1 w-7 mt-3 ' />
              <p className='text-[1.2rem] font-bold text-[#818891] smallScreens:text-[1rem]'>Mission and Vision</p>
              <img src={line} alt="" className='h-1 w-7 mt-3' />
            </div>

            <div className='flex items-start justify-start mt-8'>
              <h1 className='font-bold text-[3.4rem] text-center smallScreens:text-[2rem]'>Commitment to Excellence</h1>
            </div>
            <p className="text-[#64666C] leading-relaxed text-[1.6rem] mt-10 mb-10">
              Our goal is to remove obstacles and create opportunities for your small business to thrive. With innovative solutions and a dedicated team by your side, we’ll help you focus on what truly matters: growing your business and reaching your goals.
            </p>
            <div className="flex items-start mb-20 smallScreens:block smallScreens:text-center">
              <img
                src={mission}
                alt="icon"
                className="w-[6.6rem] h-[6.6rem] mr-6 smallScreens:mx-auto"
              />
              <div>
                <h3 className="text-[2.2rem] font-semibold text-gray-900 mb-2">
                  Our Mission
                </h3>
                <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                  Our mission is simple: to help small business owners like you
                  succeed, one step at a time. We strive to take the guesswork out
                  of running your business so you can focus on building your
                  dream.
                </p>
              </div>
            </div>
            <div className="flex items-start smallScreens:block smallScreens:text-center">
              <img
                src={vision}
                alt="icon"
                className="w-[6.6rem] h-[6.6rem] mr-6 smallScreens:mx-auto"
              />
              <div>
                <h3 className="text-[2.2rem] font-semibold text-gray-900 mb-2">
                  Our Vision
                </h3>
                <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                  We envision a world where small businesses thrive as the
                  backbone of the economy, supported by innovative solutions and a
                  strong network of resources.
                </p>
              </div>
            </div>
          </div>
          <div className="w-full mediumScreens:w-1/2 relative">
            <img
              src={about2}
              alt="Professional"
              className="object-contain"
            />
            {/* <div className="absolute top-40 -left-20 bg-[#173363] rounded-lg p-6">
              <img
                src={abouticon1}
                alt="icon"
                className="w-[3.949rem] h-[4rem] object-contain smallScreens:h-6 smallScreens:w-6"
              />
            </div>
            <div className="absolute -bottom-20 left-1/2 transform -translate-x-1/2">
              <img
                src={abouticon3}
                alt="icon"
                className="w-[10.7rem] h-[10.7rem]"
              />
            </div> */}
          </div>
        </div>
      </div>
      <div className="bg-white py-8 px-6 sm:px-12 lg:px-20">
      <div className='flex items-center justify-center gap-12 mt-2'>
          <img src={line} alt="" className='h-1 w-7' />
          <p className='text-xl smallScreens:text-[1rem] font-bold text-[#818891]'>Trusted Affiliates</p>
          <img src={line} alt="" className='h-1 w-7' />
        </div>
        {/* <div className='flex items-center justify-center mt-8'>
          <h1 className='font-bold text-[3.4rem] text-center w-2/5 smallScreens:text-[2rem]'>Our Trusted Companies</h1>
          <p className='text-[#6A6A6A] text-[1.8rem] smallScreens:text-[1.2rem] font-normal'>At SBAAA LLC, we partner with a variety of industry-leading organizations to ensure our clients have access to the best tools and resources. While this is not a comprehensive list, here are some of the trusted names we work with across bookkeeping, payroll, advisory, and small business needs:</p>
        </div> */}
           <div className="text-center py-10 px-4 sm:px-6 lg:px-8">
                <h1 className="text-[4rem] md:text-[3rem] smallScreens:text-[3rem] font-bold text-gray-800"> Our Trusted Companies</h1>
                <p className='text-[#6A6A6A] text-[1.8rem] smallScreens:text-[1.2rem] font-normal mt-4'>At SBAAA LLC, we partner with a variety of industry-leading organizations to ensure our clients have access to the best tools and resources. While this is not a comprehensive list, here are some of the trusted names we work with across bookkeeping, payroll, advisory, and small business needs:</p>
            </div>
        <CarouselComponent/>
      </div>
      <div className='bg-[#F2F2F282] py-20'>
          <div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row items-center gap-12">
          <div className="w-full lg:w-1/3">
            <div className='flex items-center justify-center gap-12 mt-[5.8rem] smallScreens:mt-0'>
              <img src={line} alt="" className='h-1 w-7' />
              <p className='text-xl smallScreens:text-[1rem] font-bold text-[#818891]'>Our Values</p>
              <img src={line} alt="" className='h-1 w-7' />
            </div>
            <h2 className="text-[3.4rem] font-bold text-gray-900 mb-6 leading-tight smallScreens:text-[2rem] smallScreens:text-center">
              The Values That Drive Us
            </h2>
            <p className="text-gray-600 text-[1.6rem] leading-relaxed">
              At SBAAA LLC, we are guided by a set of core values that shape everything we do. Our commitment to integrity, innovation, and community drives us to empower small business owners with the tools and support they need to succeed.
            </p>
          </div>
          <div className="w-full lg:w-2/3 flex justify-center ">
            <div className="relative">
              <img
                src={aboutuslast}
                alt="Team Collaboration"
                className="w-[50.4rem] h-[50.7rem] rounded-xl smallScreens:h-60"
              />
            </div>
          </div>
          <div className="w-full lg:w-1/3 space-y-8 ml-4">
            <div>
              <h3 className="text-[#173363] font-semibold text-[1.8rem] mb-2">
                Empowerment
              </h3>
              <p className="text-gray-600 text-[1.6rem] leading-relaxed">
                Providing tools and resources that enable entrepreneurs to achieve their goals.
              </p>
            </div>
            <div>
              <h3 className="text-[#173363] font-semibold text-[1.8rem] mb-2">
                Simplicity
              </h3>
              <p className="text-gray-600 text-[1.6rem] leading-relaxed">
                Offering straightforward, effective solutions to complex business challenges.
              </p>
            </div>
            <div>
              <h3 className="text-[#173363] font-semibold text-[1.8rem] mb-2">
                Collaboration
              </h3>
              <p className="text-gray-600 text-[1.6rem] leading-relaxed">
                Building strong partnerships with industry leaders and fostering a community of like-minded entrepreneurs.
              </p>
            </div>
            <div>
              <h3 className="text-[#173363] font-semibold text-[1.8rem] mb-2">
                Sustainability
              </h3>
              <p className="text-gray-600 text-[1.6rem] leading-relaxed">
                Promoting long-term growth and success for small businesses.
              </p>
            </div>
          </div>
        </div>
   
      </div>
      <div className="bg-white py-20 px-6 sm:px-12 lg:px-20">
     <div className='flex items-center justify-center gap-12 smallScreens:mt-0'>
          <img src={line} alt="" className='h-1 w-7' />
          <p className='text-xl smallScreens:text-[1rem] font-bold text-[#818891]'>Our Challenges</p>
          <img src={line} alt="" className='h-1 w-7' />
        </div>

        <div className='flex items-center justify-center'>
          <h1 className='font-bold text-[3.4rem] text-center w-2/3 smallScreens:text-[2rem] smallScreens:text-center'>Your Challenges, Our Solutions</h1>
        </div>

        <div className='flex items-center justify-center text-center mt-10'>
          <p className='text-[1.6rem] text-center w-2/3 text-[#64666C]'>We know small business ownership isn’t easy. The long hours, financial worries, and constant decision-making can take a toll. That’s why everything we offer is designed to address your pain points</p>
        </div>
        <div className=" py-20 px-4 lg:px-8 smallScreens:px-4">
          <div className="max-w-[125rem] mediumScreens:gap-40  mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">

            {aboutusData.map((card, index) => (
              <ChooseUsCard
                key={index}
                imageSrc={card.imageSrc}
                title={card.title}
                description={card.description}

              />
            ))}
          </div>
        </div>
      </div>
     
    </>
  )
}

export default AboutUs
